<template>
  <div class="px-4 py-6 space-y-5">
    <section class="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#0d4169] to-[#245ea6] text-white p-6 shadow-xl">
      <div class="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-white/10 blur-2xl"></div>
      <div class="absolute -left-6 bottom-0 h-24 w-24 rounded-full bg-white/5"></div>
      <p class="text-xs font-bold uppercase tracking-widest text-white/70">Ahun Jobs</p>
      <h1 class="mt-2 text-2xl font-extrabold leading-tight">Welcome to the Job Platform!</h1>
      <p class="mt-3 text-sm text-white/85 leading-relaxed max-w-sm">
        Looking for employees? Post a job in minutes. Looking for work? Browse opportunities and apply.
      </p>
    </section>

    <section class="card-panel p-5 space-y-3">
      <h2 class="text-base font-bold text-slate-800 text-left">For Employers</h2>
      <p class="text-sm text-slate-600 text-left leading-relaxed">
        Click the button below to post your job. An administrator will review it before it goes live on the channel.
      </p>
      <button type="button" class="btn-primary" @click="$router.push({ name: 'post_job' })">
        Post Job
      </button>
      <button type="button" class="btn-secondary" @click="$router.push({ name: 'my_jobs' })">
        See My Jobs
      </button>
    </section>

    <section class="card-panel p-5 space-y-3">
      <h2 class="text-base font-bold text-slate-800 text-left">For Job Seekers</h2>
      <p class="text-sm text-slate-600 text-left leading-relaxed">
        Open a job from the Telegram channel Apply button, or track applications you already submitted.
      </p>
      <button type="button" class="btn-secondary" @click="$router.push({ name: 'my_applications' })">
        Check My Applications
      </button>
    </section>

    <p v-if="sessionExpired" class="text-center text-xs text-rose-600 font-medium">
      Your session expired. You have been signed in again with Telegram.
    </p>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'WelcomeView',
  setup() {
    const route = useRoute()
    const sessionExpired = computed(() => route.query.session === 'expired')
    return { sessionExpired }
  },
}
</script>
